var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
/**
 * everytime window is resized this hook returns the latest width and height values of the window
 * and will trigger a re-render of the component that uses it
 * @returns [windowWidth, windowHeight]
 */
export function useOnWindowResize() {
    var _a = __read(useState(window.innerWidth), 2), windowWidth = _a[0], setWindowWidth = _a[1];
    var _b = __read(useState(window.innerHeight), 2), windowHeight = _b[0], setWindowHeight = _b[1];
    var setWindowWidthHeight = function () {
        setWindowWidth(window.innerWidth);
        setWindowHeight(window.innerHeight);
    };
    useEffect(function () {
        window.addEventListener("resize", setWindowWidthHeight);
        return function () { return window.removeEventListener("resize", setWindowWidthHeight); };
    }, []);
    return [windowWidth, windowHeight];
}
